import { render } from "./Theme1HomePagePart3WhyUs.vue?vue&type=template&id=60d27c18"
import script from "./Theme1HomePagePart3WhyUs.vue?vue&type=script&lang=js"
export * from "./Theme1HomePagePart3WhyUs.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__